import { configureStore } from '@reduxjs/toolkit';
import menuContent from './Slices/menuContent';

const store = configureStore({
    reducer: {
        menuContent,
    },
});

export default store